import {
    Dialog as MUIDialog,
    DialogContent as MUIDialogContent,
    DialogTitle as MUIDialogTitle,
    styled,
    CardActions as MUICardActions,
    Card as MUICard,
    CardHeader as MUICardHeader,
    Box,
} from '@mui/material';

export const Dialog = styled(MUIDialog)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(4),
}));

export const DialogTitle = styled(MUIDialogTitle)(({ theme }) => ({
    // color: theme.palette.primary[500],
    fontSize: theme.typography.h3.fontSize,
}));

export const DialogContent = styled(MUIDialogContent)(({ theme }) => ({
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
}));

export const DialogTitleContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
}));

export const DialogContentWrapper = styled('div')(({ theme }) => ({
    position: 'relative',

    '& h2': {
        textAlign: 'center',
        margin: `0 0 24px`,
    },
    '& h3': {
        fontSize: theme.typography.body1.fontSize,
        fontWeight: 'normal',
        textAlign: 'center',
        margin: `0 0 24px`,
    },
}));

export const DialogFooter = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(6),
}));

export const Card = styled(MUICard)(({ theme }) => ({
    display: 'flex',
    height: '100%',
}));

export const CardHeader = styled(MUICardHeader)(({ theme }) => ({
    '.MuiCardHeader-title': {
        fontSize: '1.8rem',
        color: theme.palette.common.black,
    },
}));

export const CardActions = styled(MUICardActions)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 0,
}));
